import classNames from 'classnames';
import RichText from '@/components/atoms/rich-text/rich-text';
import Typography from '@/components/atoms/typography/typography';
import CtaLinkList, {
  CtaLinkListProps,
} from '@/components/organisms/cta-link-list/cta-link-list';
import Column from '@/components/utilities/column/column';
import Container from '@/components/utilities/container/container';
import Row from '@/components/utilities/row/row';
import styles from './text-block.module.scss';

export interface TextBlockProps {
  /** The class name to apply */
  className?: string;
  /** An array of links to show */
  ctaLinks?: CtaLinkListProps['items'];
  /** The text to show as a headline */
  headline?: string | null;
  /** The text to show as a pre headline */
  preHeadline?: string | null;
  /** The text to show as a sub headline */
  subHeadline?: string | null;
  /** The rich text to show as a description */
  text?: string | null;
}

const TextBlock = ({
  className,
  ctaLinks = [],
  headline,
  preHeadline,
  subHeadline,
  text,
}: TextBlockProps) => {
  return (
    <div className={classNames(styles.component, className)}>
      <Container>
        <Row>
          <Column
            className={styles.column}
            offset={{ laptop: 2 }}
            width={{ laptop: 8 }}
          >
            {(preHeadline || headline) && (
              <div className={styles.headlineWrapper}>
                {preHeadline && (
                  <Typography
                    className={styles.caption}
                    tag="small"
                    tagStyle="subHeading"
                  >
                    {preHeadline}
                  </Typography>
                )}

                {headline && (
                  <Typography
                    className={styles.headline}
                    tag="h2"
                    tagStyle="displayMedium"
                  >
                    {headline}
                  </Typography>
                )}
              </div>
            )}

            {subHeadline && (
              <Typography
                className={styles.subHeadline}
                tag="h3"
                tagStyle="bodyLargeBold"
              >
                {subHeadline}
              </Typography>
            )}

            {text && <RichText text={text} />}

            {ctaLinks.length > 0 && <CtaLinkList items={ctaLinks} />}
          </Column>
        </Row>
      </Container>
    </div>
  );
};

TextBlock.displayName = 'TextBlock';

export default TextBlock;
